/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { Trans, useTranslation } from "next-i18next";
import React from "react";

import LinkText from "components/LinkText";

interface IPersonalInformationInfo {
  className?: string;
}

export const PersonalInformationInfo = ({
  className,
}: IPersonalInformationInfo) => {
  const { t } = useTranslation("translations");
  return (
    <p className={className}>
      <Trans
        i18nKey={t("web_personal_data_information", "")}
        components={{
          // TODO remove once translation key is changed to <br />
          1: <br />,
          // TODO remove once translation key is changed to <link>
          4: <LinkText bold href={t("privacy_policy")} />,
          bold: <strong />,
          br: <br />,
          link: <LinkText bold href={t("privacy_policy")} />,
        }}
      />
    </p>
  );
};

export default PersonalInformationInfo;
